import { Injectable } from '@angular/core';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiEndpoints } from '../../constants/api-endpoints';
import { HttpUtilityService } from '../http.utility.service';

@Injectable({ providedIn: 'root' })
export class AdminManageService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  searchAdminManage(filters: any): Observable<HttpResponse<any[]>> {
    let params = new HttpParams().set('Status', filters.status);
    if (filters.companyCode) params = params.set('Ccn', filters.companyCode);
    if (filters.buyer) params = params.set('Buyer', filters.buyer);
    if (filters.purchasingOffice)
      params = params.set('Purchasing', filters.purchasingOffice);
    if (filters.pnaNo) params = params.set('PnaNo', filters.pnaNo);

    return this.httpUtilityService.getByParam<any[]>(
      apiEndpoints.adminMangeSearch,
      params
    );
  }

  getActiveBuyers(currentPurchasing: string): Observable<HttpResponse<any[]>> {
    let endpoint = `${
      apiEndpoints.activeBuyersList
    }?currentPurchasing=${encodeURIComponent(currentPurchasing)}`;
    return this.httpUtilityService.get<any[]>(endpoint);
  }

  updatePnaRequest(payload: any): Observable<HttpResponse<any>> {
    return this.httpUtilityService.post<any>(
      apiEndpoints.updatePnaRequest,
      payload
    );
  }

  getUserDetails(userEmail: string): Observable<HttpResponse<any>> {
    let endpoint = `${
      apiEndpoints.checkAdminAccess
    }?user_email=${encodeURIComponent(userEmail)}`;
    return this.httpUtilityService.get<any>(endpoint);
  }
}
